<template>
  <div class="page-root">
    <top-navigation-layout :current="currentPosition" @onChange="onChange" />
    <div class="root">
      <!-- <keep-alive> -->
      <router-view />
      <!-- </keep-alive> -->
    </div>
    <div class="footer">
      <div class="copy-right">
        <div>
          © 1995-{{ curYear }} {{ $t('companyName') }}
          <a
            href="https://beian.miit.gov.cn/"
            target="_blank"
            style="color: inherit; cursor: pointer; text-decoration: none"
          >
            {{ $t('recordName') }}
          </a>
        </div>
        <!-- <div></div> -->
      </div>
      <div :class="$i18n.locale == 'en-US' ? 'r-title-en' : 'r-title'">
        {{ $t('goal1') }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('goal2') }}
      </div>
    </div>
  </div>
</template>

<script>
import TopNavigationLayout from '@views/components/top-navigation-layout'
export default {
  name: 'Entry',
  components: {
    TopNavigationLayout
  },
  data() {
    return {
      currentPosition: -1,
      visitedList: [],
      curYear: new Date().getFullYear()
    }
  },
  mounted() {
    // this.$router.replace({
    //   name: 'Home'
    // })
  },
  methods: {
    // 切换顶部导航
    onChange(list, pos, router) {
      if (pos == -1) {
        this.$router.replace({
          name: 'Home'
        })
      } else {
        if (router)
          this.$router.replace({
            name: router
          })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page-root {
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .root {
    flex: 1;
    height: 100%;
    .root-item {
      height: 100%;
    }
  }
  .footer {
    height: 8.2vh;
    background: url('~@images/bg/footer.png') no-repeat;
    background-size: 100% 100%;
    position: relative;
    .copy-right {
      color: #fff;
      font-size: 0.86vw;
      position: absolute;
      left: 13vw;
      line-height: 8.2vh;
    }
    .r-title {
      color: #fff;
      position: absolute;
      right: 12vw;
      top: 2vh;
      font-size: 1.3vw;
    }
    .r-title-en {
      color: #fff;
      position: absolute;
      right: 4vw;
      top: 2vh;
      font-size: 1.3vw;
    }
  }
}
</style>
